(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oll-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  document.querySelectorAll('.oll-nav__details[open]').forEach(function(menu) { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('.oll-nav__details[open]').forEach(function(menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); });
});
  } catch(e) { console.error(e); }
})();

})();
